import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, useHistory, useLocation, withRouter } from 'react-router';
import { Layout } from 'antd';
import ScrollToTopOnMount from '../scroll_to_top_on_mount/ScrollToTopOnMount';
import SubnavTabs from '../subnav_tabs/SubnavTabs';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { getWorkOrderArchivalKey } from '../../utils/WorkOrderUtils';
import { getAttentionDashboard } from '../../thunks/attention_dashboard_thunks';
import { withUserType } from '../withUserType';

const { Content } = Layout;
const style = require('./SupplierWorkOrdersOverviewPage.less');

const SupplierWorkOrdersOverviewPage = ({
	companyConfig,
	childRoutes,
	defaultView,

	currentUser,
	getWorkOrderDefaultView,
}) => {
	const [loading, setLoading] = useState(!defaultView);
	const history = useHistory();
	const location = useLocation();
	const defaultFilters = useMemo(() => nullSafeGet('filterValue', defaultView), [defaultView]);

	const archived = useMemo(
		() =>
			defaultFilters === null || defaultFilters === undefined
				? 'active'
				: defaultFilters[getWorkOrderArchivalKey(currentUser)] === true
				? 'archived'
				: defaultFilters[getWorkOrderArchivalKey(currentUser)] === undefined
				? 'all'
				: 'active',
		[defaultFilters]
	);

	const handleTabChange = useCallback(
		(key: string) => {
			history.push(`/supplier/workOrders/overview/${key}`);
		},
		[history]
	);

	const checkTabActive = useCallback(
		(key: string) => {
			return location.pathname.includes(key);
		},
		[location.pathname]
	);

	const tabs = [
		{ key: 'active', name: 'Active' },
		{ key: 'archived', name: 'Archived' },
		{ key: 'all', name: 'All' },
		{
			key: 'scheduled',
			name: 'Service Schedule',
		},
	];

	useEffect(() => {
		if (!defaultView) {
			getWorkOrderDefaultView().then((view) => {
				setLoading(false);
			});
		}
	}, []);

	if (loading) return null;
	return (
		<div>
			<ScrollToTopOnMount />
			<div>
				<Route
					path="/supplier/workOrders/overview"
					exact
					render={() => <Redirect to={{ pathname: `/supplier/workOrders/overview/${archived}` }} />}
				/>
				<Content className="workOrdersPage" style={{ padding: '0 0.5em' }}>
					<div
						style={{
							margin: '0 -8px',
							padding: '24px',
							paddingBottom: 0,
							background: nullSafeGet('detail.config.theme.navblock', companyConfig),
							marginBottom: 8,
						}}
					>
						<div style={{ marginBottom: 24 }}>
							<h4
								style={{
									color: 'rgba(255, 255, 255, 0.9)',
									marginRight: 8,
									marginBottom: 0,
								}}
							>
								Work Orders
							</h4>
						</div>
						<SubnavTabs tabs={tabs} onChange={handleTabChange} isActive={checkTabActive} />
					</div>
					{childRoutes.map((r, i) => (
						<RouteWithSubRoutes key={i} {...r} />
					))}
				</Content>
			</div>
		</div>
	);
};

const mapDispatchToProps = (dispatch, ownProps) => ({
	getWorkOrderDefaultView: () => getAttentionDashboard(dispatch, ownProps.userType),
});

const mapStateToProps = (state) => ({
	companyConfig: state.company_config,
	defaultView: state.session.defaultView,
	currentUser: state.session.currentUser,
});

export default withRouter(
	withUserType(connect(mapStateToProps, mapDispatchToProps)(SupplierWorkOrdersOverviewPage))
);
